import { useNavigate } from 'react-router-dom'
import { Inbox, PhoneMissed, ArrowRight } from 'lucide-react'
import { SectionCard } from '../../patterns/SectionCard'
import { Avatar } from '../../patterns/Avatar'
import { useAppShellStore } from '../../../stores/appShellStore'

export function ago(iso: string): string {
  const min = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 60_000))
  if (min < 1) return 'just now'
  if (min < 60) return `${min}m ago`
  const h = Math.floor(min / 60)
  if (h < 24) return `${h}h ago`
  return `${Math.floor(h / 24)}d ago`
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function ReachingYouCard({ items }: { items: any[] | null }) {
  const navigate = useNavigate()
  // Chat renders the chats shell for /channels/* only when section==='chats'
  // (the dm- branch self-corrects, bare @me does not) — switch before navigating,
  // same as PrimarySidebar handleChats.
  const goChat = (to: string) => { useAppShellStore.getState().setSection('chats'); navigate(to) }
  return (
    <SectionCard icon={<Inbox size={14} />} title="Reaching you" fill noBodyPadding
      action={
        <button type="button" onClick={() => goChat('/channels/@me')} className="text-[11px] text-muted-foreground hover:text-foreground transition inline-flex items-center gap-1">
          All chats <ArrowRight size={11} />
        </button>
      }>
      {(!items || items.length === 0) ? (
        <div className="px-5 py-6 text-center text-xs text-muted-foreground/70">Nobody is waiting on you. Clear inbox.</div>
      ) : (
        <div className="divide-y divide-border/60">
          {items.map((it, i) => (
            <button key={i} type="button" onClick={() => (it.link.startsWith('/channels/') ? goChat(it.link) : navigate(it.link))} className="w-full text-left px-5 py-3 flex items-center gap-3 hover:bg-accent/40 transition">
              <Avatar name={it.person?.name} src={it.person?.avatarUrl} className="h-7 w-7 text-xs shrink-0" />
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-medium truncate">{it.person?.name}</span>
                {it.kind === 'missed_call' ? (
                  <span className="block text-xs text-rose-400 flex items-center gap-1">
                    <PhoneMissed size={11} /> Missed call{it.count > 1 ? ` ×${it.count}` : ''} · {ago(it.lastAt)}
                  </span>
                ) : (
                  <span className="block text-xs text-muted-foreground truncate">{it.snippet || 'New message'}</span>
                )}
              </span>
              {it.kind === 'unread_dm' && (
                <span className="shrink-0 text-[11px] tabular-nums bg-primary/15 text-primary rounded-full px-2 py-0.5">{it.count}</span>
              )}
            </button>
          ))}
        </div>
      )}
    </SectionCard>
  )
}
